import React from 'react'
import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core/styles'
import HelpIcon from '@material-ui/icons/Help'
import type { StyleClasses } from '../../styles'
import Grid from '../Grid'
import Typography from '../Typography'
import StatCard from '../StatCard'
import Tooltip from '../Tooltip'
import LinearProgressLabel from '../LinearProgress/LinearProgressLabel'

const useStyles = makeStyles<Theme, StatCardProgressBarProps>(
  (theme) => ({
    root: {
      padding: theme.spacing(),
      paddingBottom: theme.spacing(0.5)
    },
    label: {
      position: 'relative',
      fontWeight: 400
    },
    newIcon: {
      position: 'absolute',
      right: -63,
      top: -8,
      fontSize: theme.typography.pxToRem(39),
      [theme.breakpoints.down('sm')]: {
        top: -9
      }
    },
    helpIcon: {
      color: theme.paintscout.palette.primary,
      fontSize: '1rem'
    },
    leftContainer: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: theme.spacing(1),
      width: '125px',
      [theme.breakpoints.down('sm')]: {
        width: '115px'
      }
    },
    toolTipLinkText: {
      color: theme.palette.common.white
    }
  }),
  { name: 'StatCardProgressBar' }
)

export interface StatCardProgressBarProps {
  classes?: StyleClasses<typeof useStyles>
  closeRate: number
  label: string
  tooltipText: string
  toolTipLink: string
  toolTopLinkText: string
}

function StatCardProgressBar(props: StatCardProgressBarProps) {
  const classes = useStyles(props)
  const { closeRate, label, tooltipText, toolTipLink, toolTopLinkText } = props

  const cardContent = (
    <Grid container alignItems="center" className={classes.root}>
      <Grid item className={classes.leftContainer}>
        <Tooltip
          icon={<HelpIcon fontSize="small" className={classes.helpIcon} />}
          interactive
          badgeRight={'-13%'}
          badgeTop={'35%'}
          content={
            <>
              {tooltipText}{' '}
              <a className={classes.toolTipLinkText} href={toolTipLink} target="_blank" rel="noopener noreferrer">
                {toolTopLinkText}
              </a>
            </>
          }
        >
          <Typography variant="h4" className={classes.label}>
            {label}
          </Typography>
        </Tooltip>
      </Grid>
      <Grid item style={{ flexGrow: 1 }}>
        <LinearProgressLabel variant="determinate" value={closeRate} />
      </Grid>
    </Grid>
  )

  return <StatCard primaryValue={''} classes={classes} cardContent={cardContent} primaryTitle="" />
}

export default StatCardProgressBar
